// extracted by mini-css-extract-plugin
var _1 = "#007ac9";
var _2 = "#575757";
var _3 = "1.5rem";
var _4 = "highlightBlue-VCM6";
var _5 = "highlightGreen-If_d";
var _6 = "highlightYellow-qQKw";
var _7 = "iconBorder-wpn0";
var _8 = "#dedede";
var _9 = "#adf";
var _a = "1rem";
var _b = "#bebebe";
var _c = "nodeIcon-eG_K";
var _d = "normalSize-L_E_";
var _e = ".8rem";
var _f = "smallSize-hFUh";
var _10 = "timeAlignmentIcon-Vpla";
var _11 = "#000";
export { _1 as "busBlue", _2 as "darkGrey", _3 as "extraLargeFontSize", _4 as "highlightBlue", _5 as "highlightGreen", _6 as "highlightYellow", _7 as "iconBorder", _8 as "lightGrey", _9 as "lightblue", _a as "mediumFontSize", _b as "mediumLightGrey", _c as "nodeIcon", _d as "normalSize", _e as "smallFontSize", _f as "smallSize", _10 as "timeAlignmentIcon", _11 as "unusedNodeColor" }
